import getConfig from 'next/config';
import { useCallback } from 'react';

const { publicRuntimeConfig } = getConfig();

type ReCaptchaVerifyHandler = () => Promise<string> | undefined;

const useReCaptcha = (): {
  handleReCaptchaVerify: ReCaptchaVerifyHandler;
} => {
  const getGrecaptcha = useCallback(() => {
    if (typeof window === 'undefined') {
      return {};
    }

    // biome-ignore lint/suspicious/noExplicitAny: grecaptcha is a third-party global with no type definitions
    return (window as any).grecaptcha;
  }, []);

  const handleReCaptchaVerify: ReCaptchaVerifyHandler = useCallback(async () => {
    if (!getGrecaptcha()) {
      console.error('reCAPTCHA is not ready yet');
      return '';
    }

    return new Promise<string>((resolve) => {
      getGrecaptcha().ready(() => {
        getGrecaptcha()
          .execute(publicRuntimeConfig.recaptchaPublicKey)
          .then((captchaCode: string) => resolve(captchaCode));
      });
    });
  }, [getGrecaptcha]);

  return {
    handleReCaptchaVerify,
  };
};

export default useReCaptcha;
